import React, { useState } from "react"

import { showSuccessToast } from "@fuse/sharedComponents/themeToast/toastUtils"

import { logAnalyticEvent } from "@firebaseConfig/analyticsUtil"

import { sendExperimentEngagementToSlack } from "@api/firebaseWrappedApis"

import VideoPreviewIcon from "@fuse/assets/images/videoPreview/video-preview-icon.svg"

interface ExclusivePreviewProps {
  onRequestAccess?: () => void
}

const ExclusivePreview: React.FC<ExclusivePreviewProps> = ({
  onRequestAccess,
}) => {
  const [contacted, setContacted] = useState(false)

  const handleRequestAccess = async (e) => {
    e.stopPropagation()
    e.preventDefault()
    logAnalyticEvent("video_preview_request_access", {
      component: "ExclusivePreview",
      action: "request_access_click",
    })
    setContacted(true)
    showSuccessToast("You're on the list!", {
      text2: "We'll reach out soon — stay tuned!",
    })
    await sendExperimentEngagementToSlack({
      experimentName: "Video Preview",
    })
    onRequestAccess?.()
  }

  return (
    <div className={`flex flex-col items-center text-center pt-4 bg-black/90`}>
      <div className="relative w-full h-48 mb-4">
        <div
          className="absolute w-[90%] h-[180px] left-[5%] top-0"
          style={{ backdropFilter: "blur(8px)" }}
        >
          <img
            src={VideoPreviewIcon}
            alt="video preview icon"
            className="absolute w-[90%] h-[180px] left-[5%] top-0 rounded-xl transform rotate-[-6deg] bg-white/5"
          />
        </div>
      </div>

      {/* Text Content */}
      <h2 className="text-base font-semibold text-white/50 my-2">
        Exclusive preview: Video Intros
      </h2>

      <p className="text-white/90 text-base mb-6">
        We're quietly rolling out our cinematic welcome experience to select
        hosts.
      </p>

      <p className="text-white/90 text-base mb-8">
        Request early access and join our priority list.
      </p>

      {contacted ? (
        <div className="w-full bg-white/10 hover:bg-white/15 text-white py-2 px-6 rounded-lg transition-colors text-base">
          You're on the list
        </div>
      ) : (
        <button
          onClick={handleRequestAccess}
          className="w-full bg-white/10 hover:bg-white/15 text-white py-2 px-6 rounded-lg transition-colors text-base"
        >
          Request early access
        </button>
      )}
    </div>
  )
}

export default ExclusivePreview
